import { ActionIcon, Button, Text, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import { IconX } from '@tabler/icons-react';
import { api } from '~/trpc-extra/api';

export const GitBranchForm = ({ initialGitBranch, testDraftId }: { initialGitBranch: string; testDraftId: string }) => {
  const trpcUtils = api.useUtils();

  const form = useForm({
    initialValues: {
      gitBranch: initialGitBranch || '',
    },
  });

  const { mutateAsync: updateGitBranch } = api.testDraft.updateGitBranch.useMutation({
    onSuccess: () => {
      trpcUtils.testContent.get.invalidate().catch(() => undefined);
      trpcUtils.testDraft.list.invalidate().catch(() => undefined);
      trpcUtils.testDraft.listByTestId.invalidate().catch(() => undefined);
      notifications.show({ message: 'Git branch updated successfully', color: 'green' });
      modals.closeAll();
    },
    onError: (e) => {
      console.error(e);
      notifications.show({ message: 'Error updating git branch', color: 'red' });
    },
  });

  return (
    <form
      onSubmit={form.onSubmit(async ({ gitBranch }) => {
        await updateGitBranch({
          testContentId: testDraftId,
          gitBranch: gitBranch.trim() || null,
        });
      })}
    >
      <div className="flex flex-col gap-4">
        <div>
          <Text
            size="sm"
            className="mb-3"
          >
            Set the git branch for this test draft.
          </Text>
          <TextInput
            label="Git Branch"
            placeholder="e.g., feature/new-test, main, develop"
            {...form.getInputProps('gitBranch')}
            data-autofocus
            rightSection={
              <ActionIcon
                variant="transparent"
                color="default"
                onClick={() => {
                  form.setFieldValue('gitBranch', '');
                }}
              >
                <IconX size={16} />
              </ActionIcon>
            }
          />
        </div>
        <div className="flex flex-row justify-end gap-4">
          <Button
            variant="default"
            onClick={() => {
              form.reset();
              modals.closeAll();
            }}
          >
            Cancel
          </Button>
          <Button type="submit">Save</Button>
        </div>
      </div>
    </form>
  );
};
